// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2laJI{font-size:16px;font-size:1.6rem;height:auto;padding:1rem;text-align:left}._2laJI .btn-inner{-ms-flex-pack:left;justify-content:left}._3GlYg{display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#fff;border:2px solid #fff;border-radius:50%;height:40px;height:4rem;justify-content:center;overflow:hidden;width:40px;width:4rem}._1ejLT{fill:#30a8ff;height:20px;height:2rem;width:20px;width:2rem}._3xDjG{color:#30a8ff}", ""]);
// Exports
exports.locals = {
	"root": "_2laJI",
	"avatar": "_3GlYg",
	"avatar__icon": "_1ejLT",
	"label": "_3xDjG"
};
module.exports = exports;
